module.exports = "/assets/data/86b2cc20da5b8e3f5b61622fc6f406e8-GL13.data.json";